import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

export default (username, password, code = null) => {
    let dataForm = { username: username, password: password }
    if (code) {
        dataForm = { username: username, password: password, code: code }
    }
    return api.post('/login', dataForm)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível fazer o login. Usuário ou senha inválido.')
        })
}
